

















import Vue from 'vue'
import { ProfileElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ProfileEl',

  props: {
    templateItemData: {
      type: Object as () => ProfileElInterface,
      required: true
    }
  }
})
